import { apiClient, getToken, getOrgId } from '@devd-client/api';
import { parseLLMResponseData } from '../helpers';

export const getMetricInfo = (chartKey: string): Promise<any> => {
  return apiClient(`/v1/tooltip/org/${getOrgId()}/metric/${chartKey}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
  });
};

const MESSAGING_API_BASE = process.env['NX_MSG_API_HOST'];

export const getAIGeneratedDataForInfoTooltip = async (
  metricCount: string,
  metricName: string,
  metricTrend: string,
  metricValueDesc: string,
  metricGoal: string
): Promise<any> => {
  const currentParams = new URLSearchParams(window.location.search);
  const params = new URLSearchParams({
    start_date: currentParams.get('start') || '',
    end_date: currentParams.get('end') || '',
    team: currentParams.get('team') || '',
  });
  try {
    const res = await fetch(
      `${MESSAGING_API_BASE}/metric/tooltipdata?` + params,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          metricCount: metricCount,
          metricName: metricName,
          metricTrend: metricTrend,
          metricValueDesc: metricValueDesc,
          metricGoal: metricGoal,
        }),
      }
    );
    const contentType = res.headers.get('content-type') || '';
    if (!contentType.includes('application/json')) {
      throw new Error('Invalid response type: expected JSON');
    }
    const data = await res.json();
    return parseLLMResponseData(data);
  } catch (error) {
    throw new Error('Error in fetching insights.');
  }
};
